export const AgentCruiseBookingData = [
  {
    key: "1",
    id: "#CB-1245",
    cruiseName: "Volkswagen Amarok",
    cruiseType: "Sedan",
    bookedBy: "Lynwood Dickens",
    bookedLocation: "Texas",
    cabin: "Interior",
    guest: "2 Adults, 1 Child",
    days: "4 Days, 3 Nights",
    pricing: "$11,569",
    bookedOn: "15 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "2",
    id: "#CR-3215",
    cruiseName: "Adventure of the Seas",
    cruiseType: "London",
    bookedBy: "James Osborne",
    bookedLocation: "California",
    cabin: "Balcony",
    guest: "2 Adults, 2 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,745",
    bookedOn: "20 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "3",
    id: "#CR-4581",
    cruiseName: "Coral Cruiser",
    cruiseType: "Edinburgh",
    bookedBy: "Steve Grieve",
    bookedLocation: "Newyork",
    cabin: "Oceanview",
    guest: "3 Adults, 2 Child",
    days: "2 Days, 1 Night",
    pricing: "$8,160",
    bookedOn: "04 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "4",
    id: "#CR-6545",
    cruiseName: "Celebrity Cruise",
    cruiseType: "Manchester",
    bookedBy: "Alene Downing",
    bookedLocation: "Florida",
    cabin: "Suite",
    guest: "2 Adults, 1 Child",
    days: "5 Days, 4 Nights",
    pricing: "$14,840",
    bookedOn: "17 Jun 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "5",
    id: "#CR-3256",
    cruiseName: "Princess Cruises",
    cruiseType: "Chelsea",
    bookedBy: "Carol Gardner",
    bookedLocation: "Georgia",
    cabin: "Concierge Class",
    guest: "1 Adult, 1 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,450",
    bookedOn: "25 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "6",
    id: "#CR-3654",
    cruiseName: "Cunard",
    cruiseType: "Las Vegas",
    bookedBy: "Enrique Archer",
    bookedLocation: "Las Vegas",
    cabin: "Outside room",
    guest: "3 Adults, 2 Child",
    days: "4 Days, 3 Nights",
    pricing: "$12,600",
    bookedOn: "02 Jul 2025",
    status: "Cancelled",
    action: "cancelled",
  },
  {
    key: "7",
    id: "#CR-1458",
    cruiseName: "Norwegian Cruise",
    cruiseType: "Salford",
    bookedBy: "Weston Carrasco",
    bookedLocation: "Texas",
    cabin: "Solo cabins",
    guest: "1 Adult, 1 Child",
    days: "2 Days, 1 Night",
    pricing: "$9,380",
    bookedOn: "12 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  
  {
    key: "8",
    id: "#CR-6589",
    cruiseName: "Azamara ",
    cruiseType: "Newyork",
    bookedBy: "Bonnie Coleman",
    bookedLocation: "California",
    cabin: "Balcony",
    guest: "1 Adult, 1 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,400",
    bookedOn: "26 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "9",
    id: "#CR-2315",
    cruiseName: "Costa Cruise",
    cruiseType: "Cambridge",
    bookedBy: "Aurora Conklin",
    bookedLocation: "Georgia",
    cabin: "Interior",
    guest: "3 Adults, 2 Child",
    days: "4 Days, 3 Nights",
    pricing: "$12,810",
    bookedOn: "10 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "10",
    id: "#CR-5414",
    cruiseName: "Oceania Cruises",
    cruiseType: "Bristol",
    bookedBy: "Robin Banks",
    bookedLocation: "Las Vegas",
    cabin: "Outside room",
    guest: "2 Adults, 1 Child",
    days: "5 Days, 4 Nights",
    pricing: "$15,450",
    bookedOn: "22 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  
];
